import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

export interface Message {
  type: string;
  message?: string;
  header: string;
}

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private alert: BehaviorSubject<Message> = new BehaviorSubject({} as Message);
  get message(): Observable<Message>{
    return this.alert.asObservable();
  };
  setAlert(message: Message){
    this.alert.next(message);
  }
}
